{
  "title": "Quality Control",
  "subtitle": "Inspect pending QC tasks against checkpoint templates before stock is released to putaway.",
  "inspect": "Inspect",
  "view": "View",
  "tabs": {
    "open": "Open QC",
    "completed": "Completed QC"
  },
  "table": {
    "grn": "GRN Number",
    "material": "Material",
    "batch": "Batch No",
    "barcode": "Barcode",
    "qty": "Received Qty",
    "supplier": "Supplier",
    "status": "Status"
  },
  "quickActions": {
    "pass": "Pass",
    "fail": "Fail",
    "hold": "Hold",
    "rework": "Rework"
  },
  "dialog": {
    "subtitle": "GRN {{grn}} · Batch {{batch}}",
    "printRequiredBeforeSubmit": "The GRN label must be printed for this item (GRN Label Print screen) before the final QC report can be submitted.",
    "noCheckpoints": "No checkpoint template is assigned to this task.",
    "checkpointsNotRecorded": "Checkpoint inspection wasn't required for this item — it was resolved with a direct Pass/Fail decision instead.",
    "mandatoryCheckpointsRequired": "Mandatory checkpoints still need a decision before you can submit: {{names}}.",
    "mandatory": "Mandatory",
    "pass": "Pass",
    "fail": "Fail",
    "actualValue": "Actual Value",
    "mustBe": "must be",
    "rejections": "Rejections",
    "addRejection": "Add Rejection",
    "noRejections": "No rejections recorded — the full received quantity is accepted.",
    "reason": "Reason",
    "rejectQty": "Qty",
    "qtySummary": "Received {{received}} · Rejected {{rejected}} · Accepted {{accepted}}",
    "rejectedExceedsReceived": "Total rejected quantity cannot exceed the received quantity.",
    "remarks": "Remarks",
    "hold": "Put on QC Hold",
    "rework": "Rework Required",
    "saveResults": "Save Results",
    "submit": "Submit Final Report"
  },
  "cancel": "Cancel"
}
